export const Types = {
  CREATE: "sessions/CREATE",
  SUCCESS: "sessions/SUCCESS",
  ERROR: "sessions/ERROR",
  DESTROY: "sessions/DESTROY",
  SAVE: "sessions/SAVE",
  AUTH_BY_TOKEN: "sessions/AUTH_BY_TOKEN"
};

const INITIAL_STATE = { loading: false };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.CREATE:
      return { ...state, loading: true };
    case Types.SUCCESS:
    case Types.ERROR:
    case Types.DESTROY:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export const Creators = {
  sessionCreate: (username, password, toSubscription = false, queryString) => ({
    type: Types.CREATE,
    payload: { username, password, toSubscription, queryString }
  }),
  authSuccess: () => ({ type: Types.SUCCESS }),
  authByToken: token => ({ type: Types.AUTH_BY_TOKEN, payload: { token } }),
  authFailure: () => ({ type: Types.ERROR }),
  invalidateSession: () => ({ type: Types.DESTROY }),
  saveSession: token => ({ type: Types.SAVE, payload: { token } })
};



// WEBPACK FOOTER //
// ./src/store/ducks/session.js